export const MapColor = [
    { min: 0, max: 2, opacity: 0.2 },
    { min: 2, max: 4, opacity: 0.4 },
    { min: 4, max: 6, opacity: 0.6 },
    { min: 6, max: 8, opacity: 0.8 },
    { min: 8, max: 10, opacity: 0.9 },
    { min: 10, max: Infinity, opacity: 1.0 },
];